import { AppRouteProps } from "@harea/component";
import React from "react";

const PermissionListContainer = React.lazy(() => import("./containers/PermissionListContainer"));
const PermissionFormContainer = React.lazy(() => import("./containers/PermissionFormContainer"));

export const PermissionRoutes: Array<AppRouteProps> = [
    {
        path: "permission",
        title: "Bo.Permission.List.Title",
        element: <PermissionListContainer />,
        children: [
            {
                path: "create",
                title: "Bo.Permission.Create.Title",
                element: <PermissionFormContainer />,
            },
            {
                path: ":id/edit",
                title: "Bo.Permission.Edit.Title",
                element: <PermissionFormContainer />,
            },
        ],
    },
];